// src/modules/operaciones/inventarios/utils/reglasPrecio.js
//
// Reglas de precio (lógica de negocio: única fuente para modal, tabla y Excel).
import { SOLO_SI_COSTO_CERO, txt, num } from "./constantes"; // Regla de costo cero y conversores seguros


export const cantidadLinea = (d) => num(d.AJUS_EXNUE) - num(d.AJUS_EXANT); // Cantidad ajustada = existencia nueva − anterior

// Una línea necesita precio si tiene artículo, cantidad ≠ 0 y (según regla) costo ≤ 0
export const necesitaPrecio = (d) =>
  txt(d.ARTI_COD) !== "" && cantidadLinea(d) !== 0 && (!SOLO_SI_COSTO_CERO || num(d.AJDE_COSTO) <= 0);

// { pc: precio a aplicar (precio > 0) | null, alerta: precio con alerta (costo promedio 0) | null }
export const infoPrecio = (d, precios) => {
  const p = necesitaPrecio(d) ? precios[txt(d.ARTI_COD)] : null; // Busca el precio calculado si la línea lo necesita
  return { pc: p && p.precio > 0 ? p : null, alerta: p && p.alerta ? p : null }; // Separa precio válido de alerta
};

export const tieneAlerta = (lineas, precios) => lineas.some((d) => infoPrecio(d, precios).alerta); // true si alguna línea tiene alerta

// Une las respuestas por lote del backend en un solo mapa de precios
export function juntarRespuestas(respuestas) {
  const mapa = {}; // Mapa arti_cod → precio
  let sysplusOk = true; // Se vuelve false si algún lote falló en Sysplus
  let errores = 0; // Contador de artículos con error
  const avisos = new Set(); // Avisos únicos del backend
  respuestas.forEach((data) => { // Recorre cada respuesta de lote
    (data.precios || []).forEach((p) => (p.error ? errores++ : (mapa[p.arti_cod] = p))); // Cuenta errores o guarda el precio
    if (data.sysplusOk === false) sysplusOk = false; // Propaga fallo de Sysplus
    if (data.aviso) avisos.add(data.aviso); // Acumula avisos sin repetir
  });
  return { mapa, sysplusOk, errores, aviso: [...avisos].join(" ") }; // Devuelve el consolidado
}

// Genera un texto resumen con el conteo de precios por origen
export function resumenPrecios(mapa) {
  const c = {}; // Contador por origen
  Object.values(mapa).forEach((p) => (c[p.origen] = (c[p.origen] || 0) + 1)); // Cuenta cada origen
  return `${c.SISTEMA || 0} del sistema, ${c.ESPECIAL || 0} especiales, ${c.ALERTA || 0} con alerta (costo promedio 0: se deja el costo original)`; // Texto final
}